import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

export const useScrollReveal = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const delay = entry.target.dataset.animateDelay || 0;
            setTimeout(() => {
              entry.target.classList.add("is-visible");
            }, Number(delay));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -50px 0px" }
    );

    document
      .querySelectorAll("[data-animate]")
      .forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
};

export const useAppSelected = () => {
  const { search } = useLocation();
  return new URLSearchParams(search).get("app") || "pdg";
};

export const useIsMobile = () => useMediaQuery({ query: `(max-width: 760px)` });

export const useCanonicalUrl = (allowedParams = []) => {
  const location = useLocation();

  // Filter query parameters if needed
  const rawParams = new URLSearchParams(location.search);
  const filteredParams = new URLSearchParams();

  allowedParams.forEach((param) => {
    const value = rawParams.get(param);
    if (value) filteredParams.set(param, value);
  });

  const paramString = filteredParams.toString();
  const origin = window.location.origin; // gets current domain

  const canonicalUrl = `${origin}${location.pathname}${
    paramString ? `?${paramString}` : ""
  }`;
  return canonicalUrl;
};
